module.exports = __webpack_public_path__ + "1f36ab3fdc8e2eb40c0bd6916f25526f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/pink-diamond-right.png
// module id = 2419
// module chunks = 0